export default "__VITE_ASSET__CZOv91_e__"